define('views/presence/Podio.Views.Presence.PresenceBar.Info',['require','translate','underscore','lib/jquery/jquery.removeClassByPrefix','lib/backbone/Backbone.PodioView','lib/Podio.Config','jst!presence/presence_bar/_new_comments_info','jst!presence/presence_bar/_typer','jst!presence/presence_bar/_typing_info'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  require('lib/jquery/jquery.removeClassByPrefix');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var podioConfig = require('lib/Podio.Config');

  var jstNewCommentsInfo = require('jst!presence/presence_bar/_new_comments_info');
  var jstTyper = require('jst!presence/presence_bar/_typer');
  var jstTypingInfo = require('jst!presence/presence_bar/_typing_info');

  return PodioView.extend({

    initialize: function(options) {

      this.elmContainer = this.options.elmContainer;
      this.model = this.options.model;
      this.shouldRenderNewCommentsInfo = this.options.shouldRenderNewCommentsInfo;
      this.hasComments = this.options.hasComments;
      this.hasTyping = this.options.hasTyping;

      this._super();
    },

    updateElementReference: function(elm) {
      this.elmContainer = elm;
    },

    render: function() {

      this.filterTypers();

      this.setStateIcon('');

      if (this.hasTyping && this.typers.length) {
        this.setStateIcon('typing');
      }
      else if (this.hasComments) {
        if (this.shouldRenderNewCommentsInfo && this.model.get('comments').getFresh().length) {
          this.setStateIcon('newComments');
        }
        else {
          this.setStateIcon('regularComments');
        }
      }

      this.renderInfoMessages();

    },

    filterTypers: function(typers) {

      // Filter current user
      var typersData = this.model.get('typers').reject(function(user) {
        return user === String(podioConfig.user.user_id);
      });

      this.typers = typersData;
    },

    setStateIcon: function(type) {
      var elmStateIconBox = this.elmContainer.find('.state-icon-box');
      elmStateIconBox.find('.state-icon').hide();

      switch (type) {
      case 'typing':
        elmStateIconBox.find('.icon-typing').show();
        break;
      case 'newComments':
        elmStateIconBox.find('.icon-16-green-comments').show();
        break;
      case 'regularComments':
        elmStateIconBox.find('.icon-16-speech-bubble').show();
        break;
      }
    },

    setTypingText: function() {

    },

    renderInfoMessages: function() {

      var text, state = '';

      this.elmContainer.removeClassByPrefix('state');

      if (this.hasTyping && this.typers.length) {
        text = this.getTypersMarkup();
        state = 'state-is-typing';
      } else if (this.hasComments) {
        if (this.model.get('comments').getFresh().length > 0 && this.shouldRenderNewCommentsInfo) {
          text = this.getFreshCommentsMarkup();
          state = 'state-is-new-comment';
        }
        else {
          state = 'state-is-regular-comment';
          if (this.model.get('comments').length === 1) {
            text = t('{0} Comment #presencebar').format('<span class="text-bold"> ' + this.model.get('comments').length + '</span>');
          } else {
            text = t('{0} Comments #presencebar').format('<span class="text-bold"> ' + this.model.get('comments').length + '</span>');
          }
        }
      }

      if (text) {
        this.elmContainer.addClass(state);
        this.elmContainer.find('.info').html(text);
        this.elmContainer.find('.info').removeClass('hidden');
      } else {
        this.elmContainer.find('.info').addClass('hidden');
      }

    },

    getFreshCommentsMarkup: function() {

      return this.getTemplate(jstNewCommentsInfo, {
        count: this.model.get('comments').getFresh().length
      });

    },

    getTypersMarkup: function() {

      var output = '';
      var suffix = t('is typing #presencebar');

      var typersHtml = _.map(this.typers, _.bind(function(user, index) {

        return this.getTemplate(jstTyper, {
          content: user.get('name')
        });

      }, this));

      // Special rendernig when 3 or more typers are around
      if (this.typers.length > 3) {

        var remainingCount = typersHtml.slice(3).length;
        var remainingText = t('{0} others #presencebar').format(remainingCount);

        var remainingHtml = this.getTemplate(jstTyper, {
          content: remainingText
        });

        typersHtml = _.first(typersHtml, 3);
        typersHtml.push(remainingHtml);

      }

      // Join the markup in to a human sentence
      typersHtml = typersHtml.toSentence(', ', ' ' + t(' and #presencebar') + ' ');

      if (this.typers.length > 1) {
        suffix = t('are typing #presencebar');
      }

      return this.getTemplate(jstTypingInfo, {
        typers: typersHtml,
        suffix: suffix
      });

    }


  });

});

